var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upcoming-card main-block my-9 text-center"},[_c('div',{staticClass:"cards__number"},[_vm._v(_vm._s(_vm._f("amount")(_vm.$BN(_vm.cards),0)))]),_c('div',{staticClass:"cards__text"},[_vm._v("Common Cards Left")])])
}
var staticRenderFns = []

export { render, staticRenderFns }